import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'app-spoken-language-selector',
    templateUrl: './spoken-language-selector.component.html',
    styleUrls: ['./spoken-language-selector.component.scss'],
})
export class SpokenLanguageSelectorComponent implements OnInit {
    @Input()
    public spokenLanguage: string;

    @Input()
    public removeLabel = false;

    @Output()
    private handleSpokenLanguageChange = new EventEmitter<string>();

    public languages = ['fr', 'en', 'nl'];

    ngOnInit() {
        this.spokenLanguage = this.spokenLanguage || this.languages[0];
    }

    onChange(spokenLanguage) {
        this.handleSpokenLanguageChange.emit(spokenLanguage);
    }
}
